import profileFormModel from "./profileFormModel";

const {
  formField: {
    clientFullName,
    registeredMobileNo,
    registeredEmailAddress,
    clientGender,
    clientAge,
    clientCode,
    city,
    nomineeFullName,
    state,
    insurancePolicies,
    trading,
    investment,
    tradingPreferences,
  },
} = profileFormModel;

export default {
  clientDetails: {
    [clientFullName.name.split('.')[1]]: "",
    [registeredMobileNo.name.split('.')[1]]: "",
    [registeredEmailAddress.name.split('.')[1]]: "",
    [clientGender.name.split('.')[1]]: "",
    [clientAge.name.split('.')[1]]: "",
    [clientCode.name.split('.')[1]]: "",
    [city.name.split('.')[1]]: "",
    [nomineeFullName.name.split('.')[1]]: "",
    [state.name.split('.')[1]]: "",
  },

  incomeSources: [],

  insuranceCoverage: {
    [insurancePolicies.name.split('.')[1]]: [],
  },
  tradingAndInvestment: {
    [trading.name.split('.')[1]]: [],
    [investment.name.split('.')[1]]: [],
    [tradingPreferences.name.split('.')[1]]: [],
  },

  monthlyIncome: {
    salary: 0,
    business: 0,
    agriculture: 0,
    interest: 0,
    rentalAmounts: [{ type: "", amount: 0 }],
  },
  
  monthlyExpenses: {
    flatType: "",
    flatAmount: 0,
    carEmi: 0,
    bikeEmi: 0,
    schoolFees: [{ child: 1, amount: 0 }],
  },
  accetList: {
    realEstateAssets: [{ property: "", location: "", assetType: "", value: 0 }],
    goldValue: 0,
    policyValue: 0,
    bankFdValue: 0,
    cashInBankValue: 0,
    businessInvestmentValue: 0,
    vehicleCarValue: 0,

  },
  libilityList: [],
};
